import { Button } from '@cleartax/wg-library-button';
import { Drawer } from '@cleartax/wg-library-drawer';
import { SearchIcon } from '@cleartax/wg-library-icons';
import { useState } from 'react';
import { THeader } from '../../../../../../pages/services/[planSeoSlug]/api/types';
import { HamburgerIcon } from '../../../../../icons';
import { HeaderLogo } from '../../utils';
import { Search } from '../search/index.component';
import { HamburgerSidebar } from './hamburger-sidebar/index';
import { NavSidebar } from './nav-sidebar/index';
import { CategoryNavbarButton } from './utils';

interface TMobileHeader {
  headerData: THeader;
}

export type TCategories = 'individual' | 'business' | '';

const CloseIcon = ({ backIcon = false }) => (
  <div className="mt-1.5">
    <span
      className={`${
        backIcon ? 'icon-arrow_back' : 'icon-clear'
      } text-brand-1000 text-s-20 font-semibold`}
    ></span>
  </div>
);

export const MobileHeader: React.FC<TMobileHeader> = ({ headerData }) => {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [navSidebarOpen, setNavSidebarOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<TCategories>('');

  const toggleSidebar = (category: 'individual' | 'business') => {
    setSelectedCategory((prevCategory) => {
      if (prevCategory !== category) {
        setNavSidebarOpen(true);
        return category;
      } else {
        setNavSidebarOpen(false);
        return '';
      }
    });
  };

  const handleCloseNavSidebar = () => {
    setSelectedCategory('');
    setNavSidebarOpen(false);
  };

  const commonCloseIconHandler = () => {
    if (selectedCategory === '')
      setMobileSidebarOpen((prevState) => !prevState);
    else handleCloseNavSidebar();
  };

  const handleCloseSearch = () => setMobileSearchOpen(false);

  return (
    <>
      <div className="wg-container h-full items-center">
        <div className="flex items-center h-12 sm:justify-between">
          <HeaderLogo />
          <div className="flex items-center">
            <Button
              mergeClasses="override"
              className="cursor-pointer"
              onClick={() => {
                setMobileSearchOpen(true);
              }}
            >
              <SearchIcon />
            </Button>
            <div
              className="cursor-pointer pl-2 w-8"
              onClick={() => commonCloseIconHandler()}
            >
              {mobileSidebarOpen || navSidebarOpen ? (
                <CloseIcon />
              ) : (
                <HamburgerIcon />
              )}
            </div>
          </div>
        </div>
        <Drawer
          onCloseCallBack={() => setMobileSearchOpen(false)}
          isOpen={mobileSearchOpen}
          direction={'right'}
          width={'full'}
          minWidth={300}
          animationDuration={300}
          hideIcon={true}
        >
          <div className="w-full flex items-start h-full overflow-hidden">
            <Search open={mobileSearchOpen} closeCB={handleCloseSearch} />
          </div>
        </Drawer>
        <NavSidebar
          open={navSidebarOpen}
          closeCB={handleCloseNavSidebar}
          headerData={headerData}
          categorySelected={selectedCategory}
        />
        <HamburgerSidebar
          open={mobileSidebarOpen}
          closeCB={setMobileSidebarOpen}
        />
      </div>
      <div className="w-full">
        <div className={`wg-container flex items-center h-8 bg-white w-full`}>
          <CategoryNavbarButton
            category={'individual'}
            selectedCategory={selectedCategory}
            toggleSidebar={() => toggleSidebar('individual')}
          />
          <CategoryNavbarButton
            category={'business'}
            selectedCategory={selectedCategory}
            toggleSidebar={() => toggleSidebar('business')}
          />
        </div>
      </div>
    </>
  );
};
